import React from 'react';
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvExMaterialItemDetailEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ height: '500px' }}
            contentStyle={{ height: '400px', width: "730px" }}
            formTitle={<FormTitle formObject={formObject} value='Order Item' />}
            formObject={formObject} >
            <div className="uiitemDetailMain" >

                <div className="uiROHeader">
                    <div style={{ display: "inline-block" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemIdReadOnly" }} value="Item" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemIdReadOnly" }} className='uiVal' />
                    </div>
                    <FormWrapper customWrapper="div" wrapperStyle={{ display: "inline-block" }} formObject={formObject} rowKey="" action={{ paramName: "itemSearchContainer" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemId" }} value="Item Id / No" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="20"
                            action={{ InputType: "input", paramName: "itemId" }} />
                        <FormButton formObject={formObject} rowKey="" className="uiSaveAction" text={<SarasTrans value="Update Item" />}
                            action={{ actionId: "refresh",  actionParam: { changeitem: 1 } }}
                        />
                    </FormWrapper>
                    <div style={{ display: "inline-block" }}>
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemAgeCat" }} value="New / Old" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "70px" }}
                            action={{ InputType: "ac", paramName: "itemAgeCat", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />

                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat" }} value="Category" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "90px" }}
                            action={{ InputType: "ac", paramName: "transCat", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />
                    </div>
                </div>
                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "itemQtyContainer" }} >
                    <div>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty1" }} value="Quantity" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                            action={{ InputType: "input", actionId: "refresh", paramName: "qty1", actionParam: { formulaSource: "QT1", updateNetAmount: "1" } }} />
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty1uom" }} />
                        <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey="" action={{ paramName: "itemQty2Container" }} >
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty2" }} value="and" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                action={{ InputType: "input", actionId: "refresh", paramName: "qty2", actionParam: { formulaSource: "QT2", updateNetAmount: "1" } }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty2uom" }} />
                        </FormWrapper>
                    </div>
                </FormWrapper>
                <div>
                    <ul className="uiItemPopupForm">
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNo" }} value="Reference No" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "input", paramName: "refNo" }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemName" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Reference Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInputLong"
                                action={{ InputType: "input", paramName: "itemName" }}
                            />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemDesc" }} value="Description" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiFrmText" rows="3" cols="82" maxlength="1000"
                                action={{ paramName: "itemDesc" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "wrkFlow" }} value="Workflow Detail" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "input", paramName: "wrkFlow" }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "packageContainer" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyPackage" }} value="Packing Qty" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                action={{ InputType: "input", paramName: "qtyPackage" }}
                            />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "packageUnit" }} value="Packing Unit" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" id="deliveryModeTxt" action={{
                                InputType: "ac",
                                actionId: "refresh", paramName: "packageUnit", acMethod: "Units", actionParam: { updateNetAmount: "1" }
                            }}
                            />
                        </FormWrapper>
                    </ul>
                </div>
            </div>
        </FormDialog>
    )
}

export default withView(InvExMaterialItemDetailEditor, "itemDetail", "itemDetail")